/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';


export interface EsercentePraticaBackofficeRowDTO { 
    id?: string;
    codice_pratica?: string;
    tipo_pratica_id?: string;
    tipo_pratica_titolo?: string;
    comune_id?: string;
    comune_nome?: string;
    stato?: RichiestaPraticaEsercenteStatus;
    timestamp_richiesta?: string;
    inserita_da_operatore?: boolean;
}



